
import Vue from 'vue';
import { appendPx } from '../Token/helper/tokenHelper';
import WebText from '../Text/Text.vue';
import ArrowRightIcon from '../../Icons/ArrowRightIcon.vue';
/**
 * Collapsible / Accordion Component.
 *
 * This template consist of:
 *
 * - Collapsible bar with Title and Arrow Icon
 * - Collapsible content below the bar.
 */
export default Vue.extend<any, any, any, any>({
  name: 'Collapsible',
  inheritAttrs: false,
  components: {
    ArrowRightIcon,
    WebText
  },
  props: {
    /**
     * The title of the Collapsible.<br />
     * Put empty string for custom collapsible header.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Make content to rows instead column.
     */
    rows: {
      type: Boolean,
      default: false
    },
    /**
     * Position of the arrow of Collapsible bar.<br />
     * Possible value: `left` | `right`.
     */
    arrowPosition: {
      type: String,
      default: 'left'
    },
    /**
     * The color of the arrow of Collapsible bar.<br />
     * Possible value: `black` | `primary`.
     */
    arrowColor: {
      type: String,
      default: 'black'
    },
    /**
     * Background color hex for collapsible content.
     */
    backgroundColor: {
      type: String,
      default: '#fff'
    },
    /**
     * Eucalyptus Text variant of the collapsible title.
     */
    variant: {
      type: String,
      default: ''
    },
    /**
     * Eucalyptus Text ink of the collapsible title.
     */
    ink: {
      type: String,
      default: ''
    },
    /**
     * Make header of the collapsible bar by slot.
     */
    useCustomHeader: {
      type: Boolean,
      default: false
    },
    /**
     * Text color of the collapsible title when closed.
     */
    color: {
      type: String,
      default: '#919191'
    },
    /**
     * Text color of the collapsible title when opened.
     */
    activeColor: {
      type: String,
      default: '#000'
    }
  },
  data() {
    return {
      active: false,
      scrollHeight: 0
    };
  },
  computed: {
    contentHeight() {
      if (this.$refs.contentRef) {
        // @ts-ignore
        this.scrollHeight = this.$refs.contentRef.scrollHeight + 12;
        return appendPx(this.scrollHeight /* padding */);
      }
      return null;
    }
  },
  methods: {
    resetContentHeight() {
      this.scrollHeight = 0;
    },
    handleToggle() {
      this.$emit('click', !this.active);
      this.active = !this.active;
    }
  }
});
